function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12_273)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M7.60434 16.5765L14.9746 12.2217L7.60434 8.87805L0.24292 12.2217L7.60434 16.5765Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M7.60434 8.87805V0L0.24292 12.2217L7.60434 16.5765V8.87805Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M7.60437 16.5765L14.9746 12.2217L7.60437 0V8.87805V16.5765Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M7.60434 17.969L0.24292 13.6231L7.60434 24V17.969Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M14.9746 13.6231L7.60437 17.969V24L14.9746 13.6231Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12_273"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 24,
  fill: "white"
})));

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.e7e04fc5.svg";
export { ForwardRef as ReactComponent };